import {
  As,
  Button,
  Flex,
  FlexProps,
  Heading,
  OmitCommonProps,
  Stack,
} from "@chakra-ui/react";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { useLang } from "../lib/lang";
import LanguageSwitcher from "./LanguageSwitcher";
import { Logo } from "./Logo";

const LABELS = {
  pt: { terms: "Termos de Uso", privacy: "Política de Privacidade" },
  en: { terms: "Terms of Use", privacy: "Privacy Policy" },
};

const Header = (
  props: JSX.IntrinsicAttributes &
    OmitCommonProps<
      React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLDivElement>,
        HTMLDivElement
      >,
      keyof FlexProps
    > &
    FlexProps &
    OmitCommonProps<any, keyof FlexProps> & { as?: As<any> | undefined }
) => {
  const lang = useLang();
  const prefix = lang === "en" ? "/en" : "";
  const t = LABELS[lang];

  return (
    <Flex
      as="nav"
      role="navigation"
      width="100%"
      py="6"
      px={{ base: "4", md: "8" }}
      bg="#D03230"
      color="white"
      justify="center"
      {...props}
    >
      <Stack
        direction={{ base: "column", md: "row" }}
        align="center"
        justify="space-between"
        width="100%"
        maxW="7xl"
        spacing={4}
      >
        <Flex align="center">
          <Logo />
          <Heading
            as="h1"
            fontSize={{ base: "2xl", md: "4xl" }}
            letterSpacing="tighter"
            ml={5}
          >
            Xlung App
          </Heading>
        </Flex>
        <Stack
          direction={{ base: "column", sm: "row" }}
          align="center"
          spacing={3}
        >
          <Button
            as={RouterLink}
            to={`${prefix}/terms`}
            colorScheme="red"
            textColor="#FFF"
            variant="solid"
          >
            {t.terms}
          </Button>
          <Button
            as={RouterLink}
            to={`${prefix}/privacy`}
            colorScheme="red"
            textColor="#FFF"
            variant="solid"
          >
            {t.privacy}
          </Button>
        </Stack>
        <LanguageSwitcher />
      </Stack>
    </Flex>
  );
};

export default Header;
